module.exports = __webpack_public_path__ + "static/media/hotspot-v2.cef67623.png";